import APIService from "./api.service";

class EntregaService extends APIService {
  static endpoint = "api";
  static async registerMany({ payload, token }) {
    try {
      const response = await APIService.post(
        `/${this.endpoint}/cadastrar-entregas`,
        payload,
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      );
      return response;
    } catch (error) {
      console.log("Error on api service: ", error);
      return Promise.reject(error);
    }
  }
}

export default EntregaService;
